import type { GdprConfig } from '#src/app/pages/petitionDetails/shared/hooks';
import type { FormValues, NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';

import { normalizeCaptcha } from './normalizeCaptcha';
import { normalizeGdprConsent } from './normalizeGdprConsent';
import { normalizePostalCode } from './normalizePostalCode';
import { normalizePublic } from './normalizePublic';
import { normalizeStateCode } from './normalizeStateCode';

const resolveAddress = (values: FormValues) => {
	const { address: fullAddress } = values;

	return fullAddress
		? {
				streetAddress: fullAddress.address,
				city: fullAddress.city,
				stateCode: fullAddress.stateCode,
				countryCode: fullAddress.countryCode || '',
				postalCode: fullAddress.postalCode,
			}
		: {
				streetAddress: values.streetAddress,
				city: values.city,
				stateCode: values.stateCode,
				countryCode: values.countryCode,
				postalCode: values.postalCode,
			};
};

export function normalizeSignData(values: FormValues, gdprConfig: GdprConfig): NormalizedFormValues {
	const shareInfoWithOrganization = values.shareInfoWithOrganization ?? false;
	const { firstName, lastName, email, reasonForSigning, phoneNumber } = values;
	const { streetAddress, city, stateCode, countryCode, postalCode } = resolveAddress(values);

	return {
		firstName,
		lastName,
		email,
		phoneNumber,
		reasonForSigning: reasonForSigning || null,
		shareInfoWithOrganization,
		public: normalizePublic(values),
		marketingCommsConsent: normalizeGdprConsent(values, gdprConfig),
		recaptchaResponse: normalizeCaptcha(values),
		address: streetAddress || '',
		city,
		stateCode: normalizeStateCode({ stateCode, countryCode }),
		countryCode,
		postalCode: normalizePostalCode({ postalCode, countryCode }),
	};
}
